import React, {useState, useEffect} from 'react'
import { Textarea, Spinner, Input } from "@material-tailwind/react";
import { getUnisatRunesHolders } from '../../util/unisat-api';
import { sleep } from '../../util/api';
const { io } = require('socket.io-client');
import toast, { Toaster } from 'react-hot-toast';
import { getAllDustzeroHolders, getAllBrc20PresaleHolders } from '../../util/admin-api';

export default function Holders() {
	const [textareaText, setTextareaText] = useState("");
	const [loading, setLoading] = useState(false);
  const [ticker, setTicker] = useState("");

	const handleTapzero = async () => {
		fetchTokenData("tapzero");
	}

	const handleStamp = async () => {
		fetchTokenData("istamps");
	}

	const handleRunezero = async () => {
		fetchTokenData("dmt-runezero");
	}

  const handleDustzero = async () => {
    setLoading(true);
    let result = await getAllDustzeroHolders(1);
    setTextareaText(JSON.stringify(result));
    setLoading(false);
  }

  const handleBrc20Presale = async () => {
    if (ticker == "") {
      toast.error("Please insert ticker!");
      return;
    }
    
    setLoading(true);
    let result = await getAllBrc20PresaleHolders(ticker);
    setTextareaText(JSON.stringify(result));
    setLoading(false);
  }

	const fetchTokenData = (ticker) => {
    setLoading(true);
    let tempDatas = [];
    let total = 0;
		let holdersLength = 0;

    const trac = io('https://tap-site.trac.network', {
      autoConnect: true,
      reconnection: true,
      reconnectionDelay: 500,
      reconnectionDelayMax: 500,
      randomizationFactor: 0
    });

    trac.connect();

    trac.on('response', async function (msg) {
      if (typeof msg.call_id === 'object') {
        if (msg.call_id.cmd == 'holdersLength') {
					holdersLength = msg.result;
					for(let i = 0; i< Math.ceil(holdersLength / 500); i++) {
						getHolders(msg.call_id.ticker, 500 * i, 500, {
							cmd: 'holders',
							offset: 500 * i
						});
					}
        } else if (msg.call_id.cmd == 'holders') {
					total = total + 1;
					for(let temp of msg.result) {
						tempDatas.push(temp);
					}
					if (total >= Math.ceil(holdersLength / 500)) {
						setLoading(false);
						setTextareaText(JSON.stringify(tempDatas))
					}
        }
			} 
    });

    const getHoldersLength = async (ticker) => {
  
      trac.emit('get', {
        func: 'holdersLength',
        args: [ticker],
        call_id: { cmd: 'holdersLength', ticker: ticker }
      });
    };

    const getHolders = async (ticker, offset = 0, max = 500, call_id) => {
      trac.emit('get', {
        func: 'holders',
        args: [ticker, offset, max],
        call_id: call_id === null ? '' : call_id
      });
    };

    getHoldersLength(ticker);
  }

	const handleRunepink = async () => {
		setLoading(true);
		let start = 0;
		let limit = 100;
		let runeId = "866614:2296";
		let tempData = [];
		while(true) {
			let res = await getUnisatRunesHolders(runeId, start, limit);
			if (res.data.detail.length > 0) {
				for(let temp of res.data.detail) {
					tempData.push(temp);
				}
			}
			else break;
			start = start + limit;
			await sleep(1000);
		}
		setTextareaText(JSON.stringify(tempData));
		setLoading(false);
	}

	const downloadJSON = () => {
    const jsonString = handleCopyText();

    // Create a Blob from the JSON string
    const blob = new Blob([jsonString], { type: 'application/json' });

    // Create a URL for the Blob
    const url = URL.createObjectURL(blob);

    // Create a temporary <a> element and set attributes for download
    const a = document.createElement('a');
    a.href = url;
    a.download = 'data.json'; // Filename for download
    document.body.appendChild(a);
    a.click(); // Trigger the click event on the <a> element
    document.body.removeChild(a); // Clean up the <a> element after download
    URL.revokeObjectURL(url); // Release the URL object
  };

	const handleCopy = () => {
    navigator.clipboard.writeText(handleCopyText()).then(
      () => {
        // Successfully copied to clipboard
        toast.success('Data copied to clipboard!')
      },
      (err) => {
        // Failed to copy to clipboard
        console.error('Could not copy data: ', err);
      }
    );
  }

	const handleCopyText = () => {
		let data = JSON.stringify(textareaText);
		data = data.replace(/\\"/g, '"');
		return data.substring(1, data.length - 1);
	}

  return (
    <div className="mt-10">
			{
				loading ? <Spinner className="h-16 w-16 text-gray-900/50 fixed" color="pink"/> : <></>
			}
			<div className="w-[1000px] mb-5">
				<Input type="text" color="white" label = "Insert Ticker" className="w-[1000px]" value={ticker} onChange = {(e) => {setTicker(e.target.value)}}/>
			</div>
			<div className="w-[1000px]">
				<Textarea className="text-white" label="Holders" rows="20" value={textareaText}/>
			</div>
			<div className="flex flex-row gap-2 mt-3 justify-center">
				<div className="bg-primary cursor-pointer hover:bg-primary-hover rounded-md px-4 py-2" onClick={() => {handleTapzero()}}>TAPZERO</div>
				<div className="bg-primary cursor-pointer hover:bg-primary-hover rounded-md px-4 py-2" onClick={() => {handleStamp()}}>ISTAMPS</div>
				<div className="bg-primary cursor-pointer hover:bg-primary-hover rounded-md px-4 py-2" onClick={() => {handleRunezero()}}>DMT-RUNEZERO</div>
				<div className="bg-primary cursor-pointer hover:bg-primary-hover rounded-md px-4 py-2" onClick={() => {handleRunepink()}}>RUNEPINK</div>
				<div className="bg-primary cursor-pointer hover:bg-primary-hover rounded-md px-4 py-2" onClick={() => {handleDustzero()}}>DUSTZERO</div>
        <div className="bg-primary cursor-pointer hover:bg-primary-hover rounded-md px-4 py-2" onClick={() => {handleBrc20Presale()}}>BRC20-PRESALE</div>
				<div className="bg-primary cursor-pointer hover:bg-primary-hover rounded-md px-4 py-2" onClick={() => {downloadJSON()}}>DOWNLOAD</div>
				<div className="bg-primary cursor-pointer hover:bg-primary-hover rounded-md px-4 py-2" onClick={() => {handleCopy()}}>COPY</div>
			</div>
    </div>
  )
}
